var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "doc-toolbar d-flex flex-row" }, [
    _vm.download && !_vm.uploadedByCoApplicant
      ? _c(
          "a",
          {
            staticClass: "download-document clickable",
            on: {
              click: function ($event) {
                return _vm.handleClick("download")
              },
            },
          },
          [
            _vm.downloading
              ? _c("inline-loader")
              : _c("icon", { attrs: { name: "download" } }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }